<template>
  <div id="OrgSafe">
    <eb-header>
      <eb-break-crumb slot='breakCrumb' />
    </eb-header>
    <table class="org-safe-table">
      <tr class="safe-one">
        <th class="safe-row-one">
          名称
        </th>
        <th>
          开关
        </th>
        <th>
          状态
        </th>
      </tr>
      <tr class="safe-one">
        <td class="apply-title">截止后才能查看供应方报价</td>
        <td class="apply-user-input">
          <el-switch style="display: block;width:280px;" v-model="cutoffFlag" active-color="#13ce66" active-value="1" inactive-value="0"
            @change="cutoffFunc"></el-switch>
        </td>
        <td class="apply-regist-info">
          {{cutoffFlagText}}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import { loadSafeInfo, setSafeStatus } from '@/services/org/org-safe-service';
export default {
  components: {
    ebHeader,
    ebBreakCrumb
  },
  data() {
    return {
      departId: this.$store.state.user.userInfo.orgId,
      cutoffFlagText: '已关闭',
      cutoffFlag: '0'
    };
  },
  created() {
    this.loadSafeInfo();
  },
  methods: {
    async loadSafeInfo() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await loadSafeInfo(this.departId);
        let cutoffFlag = data.depart.cutoffFlag;
        if (cutoffFlag === '1') {
          this.cutoffFlag = '1';
          this.cutoffFlagText = '已打开';
        }
      } catch (error) {
        this.$message.error('加载失败');
      }
      this.$root.layout.isLoading = false;
    },
    async cutoffFunc() {
      if (this.cutoffFlag === '0') {
        this.cutoffFlagText = '已关闭';
      } else {
        this.cutoffFlagText = '已打开';
      }
      var param = {
        departId: this.departId,
        cutoffFlag: this.cutoffFlag
      };
      try {
        let { data } = await setSafeStatus(param);
        if (data.returnCode === '01') {
        } else {
          this.$message.error('修改失败');
        }
      } catch (error) {
        this.$message.error('修改失败');
      }
    }
  }
};
</script>
<style  scoped lang='less'>
#OrgSafe {
  .org-safe-table {
    width: 80%;
    margin: 10px 30px;
    text-align: left;
  }
  .safe-row-one {
    width: 40%;
  }
  .safe-one {
    height: 40px;
  }
}
</style>
